<template>
  <div>
    <Head :title="title" />
    <div class="max-w-full overflow-hidden bg-white rounded-md shadow">
      <form @submit.prevent="update">
        <div class="flex flex-wrap p-8 -mb-8 -mr-6">
          <text-input v-model="form.first_name" :error="form.errors.first_name" class="w-full pb-8 pr-6 lg:w-1/3" :label="__('First name')" />
          <text-input v-model="form.last_name" :error="form.errors.last_name" class="w-full pb-8 pr-6 lg:w-1/3" :label="__('Last name')" />
          <text-input v-model="form.email" :error="form.errors.email" class="w-full pb-8 pr-6 lg:w-1/3" :label="__('Email')" />
          <text-input v-model="form.second_email" :error="form.errors.second_email" class="w-full pb-8 pr-6 lg:w-1/3" :label="__('Email de Notification')" />
          <text-input v-model="form.phone" :error="form.errors.phone" class="w-full pb-8 pr-6 lg:w-1/3" :label="__('Phone')" />
          <div class="w-full pb-8 pr-6 lg:w-1/3">
            <label  class="form-label">Départements</label>
            <multi-select v-model="form.department_ids" :options="departments" optionLabel="name" filter display="chip" class="w-full form-input"/>
          </div>
            <text-input v-model="form.city" :error="form.errors.city" class="w-full pb-8 pr-6 lg:w-1/3" :label="__('City')" />
          <text-input v-model="form.address" :error="form.errors.address" class="w-full pb-8 pr-6 lg:w-1/3" :label="__('Address')" />
          <select-input v-model="form.country_id" :error="form.errors.country_id" class="w-full pb-8 pr-6 lg:w-1/3" :label="__('Country')">
            <option :value="null" />
            <option v-for="c in countries" :key="c.id" :value="c.id">{{ __(c.name) }}</option>
          </select-input>
          <text-input v-model="form.password" :error="form.errors.password" class="w-full pb-8 pr-6 lg:w-1/3" type="password" autocomplete="new-password" :label="__('Password')" />
          <select-input v-if="user.id !== auth.user.id" v-model="form.role_id" :error="form.errors.role" class="w-full pb-8 pr-6 lg:w-1/3" :label="__('Role')">
              <option :value="null" />
              <option v-for="c in roles" :key="c.id" :value="c.id">{{ __(c.name) }}</option>
          </select-input>
          <file-input v-model="form.photo" :error="form.errors.photo" class="w-full pb-8 pr-6 lg:w-1/6" type="file" accept="image/*" label="Photo" />
            <div class="flex items-center justify-start w-full lg:w-1/6"><img v-if="user.photo_path" class="block w-8 h-8 mb-2 rounded-full" :src="user.photo_path" /></div>
        </div>
        <div class="flex items-center px-8 py-4 border-t border-gray-100 bg-gray-50">
          <button v-if="user.id !== auth.user.id && user_access.user.delete && !user.canDelete" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">
            {{ __('Delete User') }} </button>
          <loading-button :loading="form.processing" class="ml-auto btn-indigo" type="submit">{{ __('Update User') }} </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import MultiSelect from 'primevue/multiselect';
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    MultiSelect,
    TextInput,
  },
  layout: Layout,
  props: {
    user: Object,
    auth: Object,
    countries: Array,
    roles: Array,
    departments: Array,
    cities: Array,
    title: String,
  },
  remember: 'form',
  data() {
    return {
        user_access: this.$page.props.auth.user.access,
      form: this.$inertia.form({
        _method: 'put',
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        email: this.user.email,
        second_email: this.user.second_email,
        phone: this.user.phone,
        city: this.user.city,
        address: this.user.address,
        country_id: this.user.country_id,
        department_ids: this.user.department_ids,
        password: '',
        role: this.user.role,
        role_id: this.user.role_id,
        photo: null
      }),
    }
  },
  created() {
    // this.setDefaultValue(this.countries, 'country_id', 'United States')
  },
  methods: {
    setDefaultValue(arr, key, value){
      const find = arr.find(i=>i.name.match(new RegExp(value + ".*")))
      if(find){
        this.form[key] = find['id']
      }
    },
    update() {
      this.form.post(this.route('users.update', this.user.id), {
        onSuccess: () => this.form.reset('password', 'photo'),
      })
    },
    destroy() {
      if (confirm('Êtes-vous sûr de vouloir supprimer cet utilisateur ?')) {
        this.$inertia.delete(route('users.destroy', this.user.id))
      }
    },
    restore() {
      if (confirm('Êtes-vous sûr de vouloir restaurer cet utilisateur ?')) {
        this.$inertia.put(route('users.restore', this.user.id))
      }
    },
  },
}
</script>
